export default {
    parts: ['container', 'badge'],
    baseStyle: {
        container: {
            backgroundColor: 'webTheme.tagOnImage'
        },
        badge: {
            color: 'webTypo.textPrimary',
            textStyle: 'badge',
            p: '6px'
        }
    },
    variants: {
        almost_gone: {
            container: {
                backgroundColor: 'webTheme.tagBrand'
            },
            badge: {
                color: 'webTypo.textOnColor',
            }
        }
    }
}
